import { DeleteFilled, PlusOutlined } from "@ant-design/icons";
import { Card, Radio, Select } from "antd";
import React, { useEffect, useState } from "react";
import ParameterValue from "./ParameterValue";
import { v4 as uuid } from "uuid";
import {
  getAllFormTemplatesIndustry,
  getAllFormTemplatesLanguages,
  getAllFormTemplatesLocations,
  getAllFormTemplatesModeOfInterviews,
  getAllFormTemplatesNoticePeriod,
  getAllFormTemplatesPositions,
  getAllFormTemplatesQualifications,
  getAllFormTemplatesSourceNames,
} from "../../../services/formTemplates/formTemplates.service";
import useAxios from "../../../hooks/useAxios";
import { getAllLocations } from "../../../services/locations/locations.service";
import { getAllInterviewStatus } from "../../../services/interviews/interviews.service";
import { getAllDepartments } from "../../../services/departments/departments.service";

const parameterList = [
  {
    label: "Date Applied",
    type: "date",
    key: "dateApplied",
  },
  {
    label: "DOB (Age)",
    type: "number",
    key: "dob",
  },
  {
    label: "Language",
    type: "multi-select",
    key: "language",
  },
  {
    label: "Qualification",
    type: "multi-select",
    key: "qualification",
  },
  {
    label: "Source of Application",
    type: "multi-select",
    key: "source",
  },
  {
    label: "Job Role looking for",
    type: "multi-select",
    key: "jobRole",
  },
  {
    label: "Preferred Location",
    type: "multi-select",
    key: "preferredLocation",
  },
  {
    label: "Mode of Interview",
    type: "multi-select",
    key: "modeOfInterview",
  },
  {
    label: "Gender",
    type: "multi-select",
    key: "gender",
  },
  {
    label: "Disability",
    type: "select",
    key: "disability",
  },
  {
    label: "State",
    type: "multi-select",
    key: "state",
  },
  {
    label: "City",
    type: "multi-select",
    key: "city",
  },
  {
    label: "Worked with us (Experienced)",
    type: "select",
    key: "workWithUs",
  },
  {
    label: "Call status",
    type: "multi-select",
    key: "callStatus",
  },
  {
    label: "Interview Status",
    type: "multi-select",
    key: "interviewStatus",
  },
  {
    label: "Industry Worked",
    type: "multi-select",
    key: "industryWorked",
  },
  {
    label: "Department",
    type: "multi-select",
    key: "department",
  },
  {
    label: "Notice Period",
    type: "multi-select",
    key: "noticePeriod",
  },
  {
    label: "Total Experience",
    type: "number",
    key: "totalExperience",
  },
  {
    label: "Open to Relocation",
    type: "select",
    key: "openToRelocation",
  },
  {
    label: "Current CTC",
    type: "number",
    key: "currentCtc",
  },
];

const operators = [
  {
    label: "Equal",
    value: "=",
  },
  {
    label: "Not Equal",
    value: "!=",
  },
  {
    label: "Less Than",
    value: "<",
  },
  {
    label: "Less Than Equal",
    value: "<=",
  },
  {
    label: "Greater Than",
    value: ">",
  },
  {
    label: "Greater Than Equal",
    value: ">=",
  },
];

const getOperators = (paramType) => {
  if (paramType === "select" || paramType === "multi-select") {
    return operators.filter((op) => op.value === "=" || op.value === "!=");
  }

  if (paramType === "date") {
    return operators.filter((op) => op.value === "=");
  }

  if (paramType === "number") {
    return operators.filter((op) =>
      ["=", "!=", "<", "<=", ">", ">="].includes(op.value),
    );
  }
  return operators.filter((op) => ["=", "!="].includes(op.value));
};

const Conditions = ({ conditions, setConditions, conditionErrors, disabled }) => {
  const api = useAxios();
  const [sources, setSources] = useState([]);
  const [qualifications, setQualifications] = useState([]);
  const [locations, setLocations] = useState([]);
  const [interviewStatus, setInterviewStatus] = useState([]);
  const [positions, setPositions] = useState([]);
  const [modeOfInterviews, setModeOfInterviews] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [callStatus, setCallStatus] = useState([]);
  const [noticePeriods, setNoticePeriods] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [industries, setIndustries] = useState([]);

  const hasError = (groupId, conditionId, field) => {
    return conditionErrors.some(
      (err) =>
        err.groupId === groupId &&
        err.conditionId === conditionId &&
        err.field === field,
    );
  };

  const getModeOfInterviews = async () => {
    try {
      const { data } = await getAllFormTemplatesModeOfInterviews(api, "user");
      setModeOfInterviews(data);
    } catch (err) {
      console.error(err);
      throw new Error("API Failed, Try again later.");
    }
  };

  const getLanguages = async () => {
    try {
      const { data } = await getAllFormTemplatesLanguages(api, "user");
      setLanguages(data);
    } catch (err) {
      console.error(err);
      throw new Error("API Failed, Try again later.");
    }
  };

  const getLocations = async () => {
    try {
      const { data } = await getAllFormTemplatesLocations(api, "user");
      setLocations(data);
    } catch (err) {
      console.error(err);
      throw new Error("API Failed, Try again later.");
    }
  };

  const getPositions = async () => {
    try {
      const { data } = await getAllFormTemplatesPositions(api, "user");
      setPositions(data);
    } catch (err) {
      console.error(err);
      throw new Error("API Failed, Try again later.");
    }
  };

  const getSources = async () => {
    try {
      const { data } = await getAllFormTemplatesSourceNames(api, "user");
      setSources(data);
    } catch (err) {
      console.error(err);
      throw new Error("API Failed, Try again later.");
    }
  };

  const getQualifications = async () => {
    try {
      const { data } = await getAllFormTemplatesQualifications(api, "user");
      setQualifications(data);
    } catch (err) {
      console.error(err);
      throw new Error("API Failed, Try again later.");
    }
  };

  const getInterViewStatus = async () => {
    try {
      const { data } = await getAllInterviewStatus(api, "user");
      setInterviewStatus(data?.map((ele) => ele?.name));
    } catch (err) {
      console.error(err);
      throw new Error("API Failed, Try again later.");
    }
  };

  const getAllCallStatus = async () => {
    try {
      const { data } = await api.get(`/callMaster`, { tokenType: "user" });
      setCallStatus(data?.callMaster?.map((ele) => ele?.name));
    } catch (err) {
      console.error(err);
      throw new Error("API Failed, Try again later.");
    }
  };

  const getAllNoticePeriods = async () => {
    try {
      const { data } = await getAllFormTemplatesNoticePeriod(api, "user");
      setNoticePeriods(data?.map((ele) => ele));
    } catch (err) {
      console.error(err);
      throw new Error("API Failed, Try again later.");
    }
  };

  const getDepartments = async () => {
    try {
      const { data } = await getAllDepartments(api, "user");
      setDepartments(data?.trfDepartment?.map((ele) => ele?.department));
    } catch (err) {
      console.error(err);
      throw new Error("API Failed, Try again later.");
    }
  };

  const getIndustries = async () => {
    try {
      const { data } = await getAllFormTemplatesIndustry(api, "user");
      setIndustries(data?.map((ele) => ele));
    } catch (err) {
      console.error(err);
      throw new Error("API Failed, Try again later.");
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        await Promise.all([
          getSources(),
          getQualifications(),
          getLocations(),
          getInterViewStatus(),
          getPositions(),
          getModeOfInterviews(),
          getLanguages(),
          getAllCallStatus(),
          getAllNoticePeriods(),
          getDepartments(),
          getIndustries()
        ]);
      } catch (err) {
        console.error(err);
      }
    };
    init();
  }, []);

  const removeGroup = (_id) => {
    setConditions((prev) => {
      return [...prev.filter((ele) => ele?._id !== _id)];
    });
  };

  const addCondition = (groupId) => {
    setConditions((prev) =>
      prev.map((group) => {
        if (group._id === groupId) {
          return {
            ...group,
            conditions: [
              ...group.conditions,
              {
                _id: uuid(),
                label: "",
                operator: "",
                value: "",
                relation: "",
                order: group?.conditions?.length || 0,
              },
            ],
          };
        }
        return group;
      }),
    );
  };

  const removeCondition = (groupId, conId) => {
    setConditions((prev) =>
      prev.map((group) => {
        if (group._id === groupId) {
          return {
            ...group,
            conditions: group.conditions.filter(
              (condition) => condition._id !== conId,
            ),
          };
        }
        return group;
      }),
    );
  };

  const updateGroupRelation = (groupId, relation) => {
    setConditions((prev) =>
      prev.map((group) =>
        group._id === groupId ? { ...group, relation } : group,
      ),
    );
  };

  const updateConditionRelation = (groupId, conId, relation) => {
    setConditions((prev) =>
      prev.map((group) => {
        if (group._id === groupId) {
          return {
            ...group,
            conditions: group.conditions.map((con) =>
              con._id === conId ? { ...con, relation } : con,
            ),
          };
        }
        return group;
      }),
    );
  };

  const onChangeParameter = (groupId, conId, label) => {
    const findLabel = parameterList.find((ele) => ele.key === label);
    const value =
      findLabel?.type === "number" || findLabel?.type === "select" ? "" : [];

    setConditions((prev) =>
      prev.map((group) => {
        if (group._id === groupId) {
          return {
            ...group,
            conditions: group.conditions.map((con) =>
              con._id === conId ? { ...con, label, operator: "", value } : con,
            ),
          };
        }
        return group;
      }),
    );
  };

  const onChangeOperator = (groupId, conId, operator) => {
    setConditions((prev) =>
      prev.map((group) => {
        if (group._id === groupId) {
          return {
            ...group,
            conditions: group.conditions.map((con) =>
              con._id === conId ? { ...con, operator } : con,
            ),
          };
        }
        return group;
      }),
    );
  };

  return (
    <div>
      {conditions?.map((group, index) => {
        const conditionLength = group?.conditions?.length;
        return (
          <>
            <Card
              key={group?._id}
              className="mb-1"
              title={`Rule ${index + 1}`}
              extra={
                <div className="flex gap-[5px]">
                  <button
                    disabled={disabled}
                    onClick={(e) => addCondition(group?._id)}
                    className={`btn-sm btn-primary ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                  >
                    <PlusOutlined /> Add Parameter
                  </button>
                  <button
                    disabled={disabled}
                    onClick={(e) => removeGroup(group?._id)}
                    className={`${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                  >
                    <DeleteFilled style={{ fontSize: "1.2rem" }} />
                  </button>
                </div>
              }
            >
              {conditionLength === 0 ? (
                <div className="flex flex-col items-center gap-2 text-gray-500">
                  <span className="text-sm">No conditions added yet</span>
                  <span className="text-xs text-gray-400">
                    Click "Add Parameters" to create one
                  </span>
                </div>
              ) : (
                <>
                  {group?.conditions?.map((con, _i) => {
                    const label = con?.label || "";
                    const param =
                      parameterList?.find((ele) => ele?.key === label)?.type ||
                      "";
                    const filterOperators = getOperators(param);

                    const isHasErrorLabel = hasError(
                      group._id,
                      con._id,
                      "label",
                    )
                      ? "error"
                      : "";
                    const isHasErrorOperator = hasError(
                      group._id,
                      con._id,
                      "operator",
                    )
                      ? "error"
                      : "";

                    const isHasErrorValue = hasError(
                      group._id,
                      con._id,
                      "value",
                    )
                      ? "error"
                      : "";

                    return (
                      <>
                        {_i !== 0 && group.conditions[_i - 1]?.relation && (
                          <div className="flex justify-start mb-2">
                            <div className="px-4 py-1 rounded-full border bg-white text-[#f8a61b] text-xs font-semibold shadow-sm">
                              {group.conditions[_i - 1]?.relation}
                            </div>
                          </div>
                        )}
                        <div
                          key={con?._id}
                          className="grid grid-cols-[30%_20%_30%_17%] gap-2 w-full mb-2 items-start"
                        >
                          <div>
                            <Select
                              disabled={disabled}
                              status={isHasErrorLabel}
                              showSearch
                              getPopupContainer={(triggerNode) =>
                                triggerNode.parentElement
                              }
                              value={con?.label || null}
                              className="w-full"
                              placeholder="Select Parameter"
                              optionFilterProp="children"
                              onChange={(value) =>
                                onChangeParameter(group?._id, con?._id, value)
                              }
                            >
                              {parameterList?.map((parameter, index) => {
                                const isParameterSelected =
                                  group?.conditions?.some(
                                    (_ele) => _ele.label === parameter?.key,
                                  );
                                return (
                                  <Select.Option
                                    key={index}
                                    value={parameter?.key}
                                    disabled={isParameterSelected}
                                  >
                                    {parameter?.label}
                                  </Select.Option>
                                );
                              })}
                            </Select>
                            {isHasErrorLabel && (
                              <p className="text-red-500 !mb-1">
                                Parameter is required
                              </p>
                            )}
                          </div>

                          <div>
                            <Select
                              disabled={disabled}
                              status={isHasErrorOperator}
                              showSearch
                              getPopupContainer={(triggerNode) =>
                                triggerNode.parentElement
                              }
                              value={con?.operator || null}
                              className="w-full"
                              placeholder="Select Operator"
                              optionFilterProp="children"
                              onChange={(value) =>
                                onChangeOperator(group?._id, con?._id, value)
                              }
                            >
                              {filterOperators?.map((operator, index) => (
                                <Select.Option
                                  key={index}
                                  value={operator?.value}
                                >
                                  {operator?.label}
                                </Select.Option>
                              ))}
                            </Select>
                            {isHasErrorOperator && (
                              <p className="text-red-500 !mb-0">
                                Operator is required
                              </p>
                            )}
                          </div>

                          <div>
                            <div style={disabled ? { pointerEvents: "none", opacity: 0.7 } : {}}>
                              <ParameterValue
                                sources={sources}
                                locations={locations}
                                qualifications={qualifications}
                                parameterList={parameterList}
                                group={group}
                                con={con}
                                isHasErrorValue={isHasErrorValue}
                                positions={positions}
                                interviewStatus={interviewStatus}
                                modeOfInterviews={modeOfInterviews}
                                languages={languages}
                                setConditions={setConditions}
                                callStatus={callStatus}
                                noticePeriods={noticePeriods}
                                departments={departments}
                                industries={industries}
                              />
                            </div>
                            {isHasErrorValue && (
                              <p className="text-red-500 !mb-0">
                                Value is required
                              </p>
                            )}
                          </div>

                          <div className="flex items-center gap-[5px] justify-end">
                            {conditionLength - 1 !== _i && (
                              <Radio.Group
                                disabled={disabled}
                                style={
                                  hasError(group._id, con._id, "relation")
                                    ? {
                                        border: "1px solid red",
                                        borderRadius: 5.6,
                                      }
                                    : {}
                                }
                                buttonStyle="solid"
                                className="flex"
                                value={con?.relation}
                                onChange={(e) =>
                                  updateConditionRelation(
                                    group?._id,
                                    con?._id,
                                    e.target.value,
                                  )
                                }
                              >
                                <Radio.Button value="AND">AND</Radio.Button>
                                <Radio.Button value="OR">OR</Radio.Button>
                              </Radio.Group>
                            )}

                            <button
                              disabled={disabled}
                              className={`${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                              onClick={() =>
                                removeCondition(group?._id, con?._id)
                              }
                            >
                              <DeleteFilled style={{ fontSize: "1.2rem" }} />
                            </button>
                          </div>
                        </div>
                      </>
                    );
                  })}
                </>
              )}
            </Card>
          </>
        );
      })}
    </div>
  );
};

export default Conditions;
